<template>
<div class="col-xl-6 box-col-6">
    <div class="widget-joins card widget-arrow">
        <div class="card-header pb-0">
            <h3>Sale details</h3>
        </div>
        <div class="card-body">
            <div class="row gy-4">
                <div class="col-sm-6" v-for="(item,index) in menuitems" :key="index">
                    <div class="widget-card">
                        <div class="d-flex align-self-center">
                            <div :class=item.iconClass><i :class=item.icon></i></div>
                            <div class="flex-grow-1">
                                <h6>{{item.title}}</h6>
                                <h5>$<span class="counter"><number
                                    class="bold "
                                    ref="number1"
                                    :from="0"
                                    :to="item.counter"
                                    :duration="5"
                                    :delay="0"
                                    easing="Power1.easeOut"
                                  /></span><span :class=item.class>{{item.numbers}}</span></h5>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>
</template>

<script>
import {
    SalesData
} from '../../../data/widgets/general/data'
export default {
    name: 'gsalesPage',
    data() {
        return {
            menuitems: SalesData
        }
    }
}
</script>
